import { useNavigate } from "react-router-dom";

import { DesktopSlashDarkIcon } from "../../assets";
import { getCodePublicProjectsRoute } from "../../utils/routes";
import { Button, Column, Row } from "../../widget";
import { PublicTemplate } from "../PublicTemplate";

interface PublicErrorTemplateProps {
  errorText: string;
  errorCode: string;
}

export const PublicErrorTemplate = ({ errorText, errorCode }: PublicErrorTemplateProps): JSX.Element => {
  const navigate = useNavigate();
  return (
    <PublicTemplate>
      <Row spacingV="2xl" justify="center" align="center">
        <Column span={12} />
      </Row>
      <Row spacingV="ml" justify="center" align="center">
        <Column span={12}>
          <DesktopSlashDarkIcon />
        </Column>
      </Row>
      <Row spacingV="ll" justify="center" align="center">
        <Column span={12}>
          <p className="body0">OOPS!</p>
        </Column>
      </Row>
      <Row spacingV="ll" justify="center" align="center">
        <Column span={12}>
          <p className="body1">{errorText}</p>
        </Column>
      </Row>
      <Row spacingV="4xl" justify="center" align="center">
        <Column span={12}>
          <p className="body3">Error code: {errorCode}</p>
        </Column>
      </Row>
      <Row spacingV="ml" justify="center" align="center">
        <Column span={12}>
          <Button text="Go home" onClick={() => navigate(getCodePublicProjectsRoute())} />
        </Column>
      </Row>
    </PublicTemplate>
  );
};
